<section class="gap-48 md-gap-16 flex">
  <section class="flex-col">
    <h1 class="heading-1 mb-24 md-mb-12">Something went wrong</h1>

    <section class="flex-col gap-16 md-gap-12 mb-32 md-mb-24">
      <section class="flex-col gap-4 md-gap-8">
        <p class="body large">Sorry, we’ve run into a booking error. {{ vm.firstMessage }}</p>
      </section>

      <app-telephone-link [phoneNumber]="vm.phoneNumber" [largeFont]="true"> </app-telephone-link>

      <section class="flex-col gap-4 md-gap-8">
        <p class="hint">
          Calls cost the standard UK landline rate. Lines open Mon-Fri 8am-5:30pm, Sat 9am-5pm, Sun 10am-4pm.
        </p>
      </section>
    </section>

    <app-button
      dataLabel="error-page-repair-page-link"
      [buttonOptions]="{
        isLink: true,
        url: vm.repairsPageUrl,
      }"
      class="mb-32 md-mb-24"
    >
      <i class="fa-light fa-arrow-left mr-8"></i>

      Back to repairs page
    </app-button>

    <p class="hint">Error code: {{ vm.errorCode }}</p>
  </section>
  <section>
    <img src="/assets/images/error-icon.png" alt="Error page alert icon" />
  </section>
</section>
